import { render, staticRenderFns } from "./VQuickTask.vue?vue&type=template&id=4b947f4e&"
import script from "./VQuickTask.vue?vue&type=script&lang=js&"
export * from "./VQuickTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports